import { useCallback, useEffect, useState } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import api from "@/lib/api";

/**
 * Guardas de generación segura de contratos (PM + disclaimer).
 * Desacoplado: usable en nube y ejecutable local (misma API).
 */
export function useContractGenerationPreflight({ clientId, trabajadorId, enabled = true }) {
  const [preflight, setPreflight] = useState(null);
  const [acepto, setAcepto] = useState(false);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!enabled || !clientId) return;
    setLoading(true);
    try {
      const { data } = await api.get("/laboral/contratos/preflight", {
        params: {
          client_id: clientId,
          trabajador_id: trabajadorId || "",
          acepto_responsabilidad: acepto,
        },
      });
      setPreflight(data);
    } catch {
      setPreflight(null);
    } finally {
      setLoading(false);
    }
  }, [clientId, trabajadorId, acepto, enabled]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const canGenerate = Boolean(preflight?.can_generate);

  return {
    preflight,
    loading,
    acepto,
    setAcepto,
    refresh,
    canGenerate,
  };
}

export function ContractPmBlockerDialog({ open, onOpenChange, message }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Representante legal requerido</AlertDialogTitle>
          <AlertDialogDescription>
            {message || "Faltan datos del Representante Legal"}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={() => onOpenChange(false)}>Entendido</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export function ContractDisclaimerDialog({ open, onOpenChange, disclaimerText, onAccept }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Contrato estándar — responsabilidad</AlertDialogTitle>
          <AlertDialogDescription>{disclaimerText}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            onClick={() => {
              onAccept?.();
              onOpenChange(false);
            }}
          >
            Acepto la responsabilidad
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
